import { render, staticRenderFns } from "./GroupsTableRow.vue?vue&type=template&id=fd79e94e&scoped=true&lang=pug&"
import script from "./GroupsTableRow.vue?vue&type=script&lang=js&"
export * from "./GroupsTableRow.vue?vue&type=script&lang=js&"
import style0 from "./GroupsTableRow.vue?vue&type=style&index=0&id=fd79e94e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd79e94e",
  null
  
)

export default component.exports